import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-date-picker";

export const siteId69: SiteIdOverrideConfig = {
  hotel: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  car: {
    date: {
      firstDayOfWeek: DayName.SUN,
      maxDaysRange: 329,
    },
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
};
